import { render, staticRenderFns } from "./SocialIconsBar.vue?vue&type=template&id=32068ab8"
import script from "./SocialIconsBar.vue?vue&type=script&lang=js"
export * from "./SocialIconsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports